// K6 — KPI hücre editöründe önceki yıla göre olağan dışı değer kararı (bloklamaz).
// Editör yazılan metni kaydedeceği şekilde (`normalizeCellInput`) okur; önceki yıl hücresi
// yalnız `filled` + sayı ise karşılaştırılır (boş / XXX / Ölçülmüyor / HESAPLANAMADI → uyarı yok).
// Kopya `KPI_COPY.cell.outlier` / `KPI_COPY.portal.outlier` — müşteri yüzeyi aynı bileşen.

import {
  formatKpiNumber,
  formatOutlierRatio,
  outlierDisplayNumber,
  outlierRatio,
  type KpiResolvedCell,
  type KpiResolvedIndicator,
} from "@mahir/shared";
import { normalizeCellInput } from "./kpi-grid-nav";
import { KPI_COPY } from "./kpi-ui";

export function kpiOutlierText(args: {
  raw: string;
  /** Editörün durum segmenti — yalnız "filled"de sayı kaydedilir. */
  mode: "filled" | "pending_xxx" | "not_measured";
  priorCell: KpiResolvedCell | undefined;
  indicator: Pick<KpiResolvedIndicator, "unit" | "valueType">;
  isClient: boolean;
}): string | null {
  const { raw, mode, priorCell, indicator, isClient } = args;
  if (mode !== "filled" || indicator.valueType === "text") return null;
  if (priorCell?.status !== "filled" || typeof priorCell.value !== "number") return null;
  const { input } = normalizeCellInput(raw, {
    unit: indicator.unit,
    valueType: indicator.valueType,
  });
  if (input.status !== "filled" || typeof input.numericValue !== "number") return null;
  const ratio = outlierRatio(input.numericValue, priorCell.value);
  if (ratio === null) return null;
  const percent = indicator.valueType === "percent";
  // formatKpiNumber 2 ondalığa yuvarlar — 0,0004 "0" görünmesin (önemli basamak yedeği)
  const show = (n: number): string =>
    `${percent ? "%" : ""}${outlierDisplayNumber(n, formatKpiNumber(n))}`;
  const copy = isClient ? KPI_COPY.portal.outlier : KPI_COPY.cell.outlier;
  return copy(show(priorCell.value), show(input.numericValue), formatOutlierRatio(ratio));
}
